import * as ACTION from './constants';

const initialState = {
  activityAudioFiles: {},
  activityVideos: {},
  bioVideo: {},
  classOverviewVideos: {},
  exerciseVideos: {},
  programOverviewVideos: {},
  welcomeVideo:{}
};

export default function reducers(state = initialState, action) {
  switch(action.type) {
    case ACTION.UPLOAD_QUEUE_BASE:
      return {...initialState};
    case ACTION.ADD_TO_QUEUE:
      return {
        ...state,
        [action.item.uploadType]: {
          ...state[action.item.uploadType],
          [action.item.id]: {
            ...action.item,
            thumbnail: null,
            timeout: false,
            streaming_video: null, // todo: thumbnail and streaming_video aren't applicable to all...
          }
        }
      };
    case ACTION.POLLING_COMPLETE:
      return {
        ...state,
        [action.item.uploadType]: {
          ...state[action.item.uploadType],
          [action.item.id]: {
            ...action.item,
          }
        }
      };
    case ACTION.POLLING_TIMEOUT:
      return {
        ...state,
        [action.item.uploadTime]: {
          ...state[action.item.uploadType],
          [action.item.id]: {
            ...action.item,
            timeout: true,
          }
        }
      };
    default:
      return state;
  }
}
